export enum PropertyType {
  SINGLE_FAMILY = 'single-family',
  TOWNHOUSE = 'townhouse',
  FLAT = 'flat',
  COMMERCIAL = 'commercial',
  OTHER = 'other',
}
